import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'
import { MissingTokensIcon } from 'pages/admin/users/users'

class AddManagedUserModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedUser: null
    }

    this.addSelectedUser = this.addSelectedUser.bind(this)
    this.selectUser = this.selectUser.bind(this)
    this.handleUserSelected = this.handleUserSelected.bind(this)
  }

  componentDidUpdate () {
    // the select picker needs to be refreshed when we fetch the users
    window.$('.selectpicker').selectpicker('refresh')
  }

  addSelectedUser () {
    const { onAddUser } = this.props

    onAddUser(this.state.selectedUser.id)
  }

  selectUser (id) {
    const { users } = this.props
    const user = users.find(u => u.id === id)
    this.setState({ selectedUser: user })
  }

  handleUserSelected (e) {
    this.selectUser(e.target.value)
  }

  render () {
    const { show, name, onClose, users } = this.props
    const { selectedUser } = this.state

    return (
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title>
            Assign user to <strong>{name}</strong>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <select
            className='selectpicker form-control'
            title='Select a user'
            data-live-search='true'
            onChange={this.handleUserSelected}
          >
            {users.map(user => (
              <option key={user.id} value={user.id} >
                <div className='user-select-option'>
                  {user.screenName}
                  {
                    !user.hasTwitterTokens &&
                    <MissingTokensIcon />
                  }
                </div>
              </option>
            ))}
          </select>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            bsStyle='primary'
            onClick={this.addSelectedUser}
            disabled={!selectedUser}
          >
            Assign User
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

AddManagedUserModal.propTypes = {
  onAddUser: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default AddManagedUserModal



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/user-permissions/add-managed-user-modal.js